import React from "react";

/**
 * Fetches and parses a JSON document once per URL.
 *
 * The payload is dropped the moment `url` changes, which is what keeps one
 * radar's data from being read as the other's. Switching from `/ai` to `/tech`
 * changes the slug in one render but the new `rd.json` only lands a tick later;
 * without this reset the whole page - and `ReleaseTimeline`, which builds its
 * TimelineJS instance once per (radar, release count) and both radars publish
 * the same number of quarters - kept rendering the previous radar's entries.
 * Consumers already treat `undefined` as "not loaded yet".
 */
export const useFetch = <D extends unknown>(url: string): D | undefined => {
  const [data, setData] = React.useState<D>();

  React.useEffect(() => {
    let cancelled = false;
    setData(undefined);

    fetch(url)
      .then((response) => response.json())
      .then((data: D) => {
        if (!cancelled) {
          setData(data);
        }
      })
      .catch((error) => {
        console.error(`fetch ${url} failed. Did the file exist?`, error);
      });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return data;
};
